import { ISelectOption } from '../models';

export const TRANSFER_TYPES: ISelectOption[] = [
  {
    title: 'SELECTION-DIALOG.TRANSFER-TYPES.CHOICES.MT-103',
    subTitle: '',
    value: 'mt-103',
    disabled: false,
  },
  {
    title: 'SELECTION-DIALOG.TRANSFER-TYPES.CHOICES.CR-202',
    subTitle: '',
    value: 'cr-202',
    disabled: false,
  },
  {
    title: 'SELECTION-DIALOG.TRANSFER-TYPES.CHOICES.CRC-909',
    subTitle: '',
    value: 'crc-909',
    disabled: false,
  },
  {
    title: 'SELECTION-DIALOG.TRANSFER-TYPES.CHOICES.N-299',
    subTitle: '',
    value: 'mt-103',
    disabled: false,
  },
  {
    title: 'SELECTION-DIALOG.TRANSFER-TYPES.CHOICES.STATEMENT',
    subTitle: '',
    value: 'statement',
    disabled: false,
  },
];

export const TRANSACTION_TYPES: ISelectOption[] = [
  {
    title: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.SWIFT.LABEL',
    subTitle: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.SWIFT.TEXT',
    value: 'swift',
  },
  {
    title: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.RTGS.LABEL',
    subTitle: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.RTGS.TEXT',
    value: 'rtgs',
  },
  {
    title: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.EAPP.LABEL',
    subTitle: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.EAPP.TEXT',
    value: 'eapp',
  },
  {
    title: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.COMESA.LABEL',
    subTitle: 'SELECTION-DIALOG.TRANSACTION-TYPES.CHOICES.COMESA.TEXT',
    value: 'comesa',
  },
];
